import "../app/swiper";
import "../app/statica";
